import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { NormalizedV2Response } from '@/types/eds/api/responses/NormalizedV2Response';
import { GetProfileDetailsPayload } from '@/domains/profileDetails/store/types';

export type ProfileDetailsState = {
  normalizedV2Response: NormalizedV2Response | null;
  uploadedAvatarUrl: string;
  isAvatarUploading: boolean;
  notificationTypes: NormalizedV2Response[] | null;
};

const initialState: ProfileDetailsState = {
  normalizedV2Response: null,
  uploadedAvatarUrl: '',
  isAvatarUploading: false,
  notificationTypes: null,
};

const profileDetailsSlice = createSlice({
  name: 'profileDetails',
  initialState,
  reducers: {
    initProfileDetailsPage: () => initialState,
    getProfileDetails: (_, _action: PayloadAction<GetProfileDetailsPayload>) => {},
    getProfileDetailsSuccess: (state, action: PayloadAction<NormalizedV2Response>) => {
      state.normalizedV2Response = action.payload;
    },
    setNotificationTypes: (state, { payload }: PayloadAction<NormalizedV2Response[]>) => {
      state.notificationTypes = payload;
    },
    uploadAvatar: (_, _action: PayloadAction<{ image: File }>) => {},
    uploadAvatarSuccess: (state, action: PayloadAction<string>) => {
      state.uploadedAvatarUrl = action.payload;
    },
    setAvatarUploading: (state, { payload }: PayloadAction<boolean>) => {
      state.isAvatarUploading = payload;
    },
  },
});

export const {
  initProfileDetailsPage,
  getProfileDetails,
  getProfileDetailsSuccess,
  uploadAvatar,
  uploadAvatarSuccess,
  setAvatarUploading,
  setNotificationTypes,
} = profileDetailsSlice.actions;

export const profileDetailsReducer = profileDetailsSlice.reducer;
export const profileDetailsReducerPath = profileDetailsSlice.reducerPath;
